import {createGlobalStyle} from "styled-components";
import fontLato400_01 from "../Assets/fonts/Lato/fontLato400_01.woff2";
import fontLato400_latin from "../Assets/fonts/Lato/fontLato400_latin.woff2";
import fontLato700_latin_ext from "../Assets/fonts/Lato/fontLato700_latin_ext.woff2";
import fontLato700_latin from "../Assets/fonts/Lato/fontLato700_latin.woff2";
import fontLato900_latin from "../Assets/fonts/Lato/fontLato900_latin.woff2";
import fontLato900_latin2 from "../Assets/fonts/Lato/fontLato900_latin2.woff2";

import fontMulish400_cyrillic_ext from "../Assets/fonts/Mulish/fontMulish400_cyrillic_ext.woff2";
import fontMulish400_cyrilli from "../Assets/fonts/Mulish/fontMulish400_cyrilli.woff2";
import fontMulish400_vietnamese from "../Assets/fonts/Mulish/fontMulish400_vietnamese.woff2";
import fontMulish400_latin_ext from "../Assets/fonts/Mulish/fontMulish400_latin_ext.woff2";
import fontMulish400_latin from "../Assets/fonts/Mulish/fontMulish400_latin.woff2";
import fontMulish600_cyrillic_ext from "../Assets/fonts/Mulish/fontMulish600_cyrillic_ext.woff2";
import fontMulish600_cyrillic from "../Assets/fonts/Mulish/fontMulish600_cyrillic.woff2";
import fontMulish600_vietnamese from "../Assets/fonts/Mulish/fontMulish600_vietnamese.woff2";
import fontMulish600_latin_ext from "../Assets/fonts/Mulish/fontMulish600_latin_ext.woff2";
import fontMulish600_latin from "../Assets/fonts/Mulish/fontMulish600_latin.woff2";
import fontMulish700_cyrillic_ext from "../Assets/fonts/Mulish/fontMulish700_cyrillic_ext.woff2";
import fontMulish700_cyrillic from "../Assets/fonts/Mulish/fontMulish700_cyrillic.woff2";
import fontMulish700_vietnamese from "../Assets/fonts/Mulish/fontMulish700_vietnamese.woff2";
import fontMulish700_latin_ext from "../Assets/fonts/Mulish/fontMulish700_latin_ext.woff2";
import fontMulish700_latin from "../Assets/fonts/Mulish/fontMulish700_latin.woff2";
import fontMulish800_cyrillic_ext from "../Assets/fonts/Mulish/fontMulish800_cyrillic_ext.woff2";
import fontMulish800_cyrillic from "../Assets/fonts/Mulish/fontMulish800_cyrillic.woff2";
import fontMulish800_vietnamese from "../Assets/fonts/Mulish/fontMulish800_vietnamese.woff2";
import fontMulish800_latin_ext from "../Assets/fonts/Mulish/fontMulish800_latin_ext.woff2";
import fontMulish800_latin from "../Assets/fonts/Mulish/fontMulish800_latin.woff2";
import fontMulish900_cyrillic_ext from "../Assets/fonts/Mulish/fontMulish900_cyrillic_ext.woff2";
import fontMulish900_cyrillic from "../Assets/fonts/Mulish/fontMulish900_cyrillic.woff2";
import fontMulish900_vietnamese from "../Assets/fonts/Mulish/fontMulish900_vietnamese.woff2";
import fontMulish900_latin_ext from "../Assets/fonts/Mulish/fontMulish900_latin_ext.woff2";
import fontMulish900_latin from "../Assets/fonts/Mulish/fontMulish900_latin.woff2";

import fontRoboto400_cyrillic_ext from "../Assets/fonts/Roboto/fontRoboto400_cyrillic_ext.woff2";
import fontRoboto400_cyrillic from "../Assets/fonts/Roboto/fontRoboto400_cyrillic.woff2";
import fontRoboto400_greek_ext from "../Assets/fonts/Roboto/fontRoboto400_greek-ext.woff2";
import fontRoboto400_greek from "../Assets/fonts/Roboto/fontRoboto400_greek.woff2";
import fontRoboto400_vietnamese from "../Assets/fonts/Roboto/fontRoboto400_vietnamese.woff2";
import fontRoboto400_latin_ext from "../Assets/fonts/Roboto/fontRoboto400_latin_ext.woff2";
import fontRoboto400_latin from "../Assets/fonts/Roboto/fontRoboto400_latin.woff2";
import fontRoboto700_cyrillic_ext from "../Assets/fonts/Roboto/fontRoboto700_cyrillic_ext.woff2";
import fontRoboto700_cyrillic from "../Assets/fonts/Roboto/fontRoboto700_cyrillic.woff2";
import fontRoboto700_greek_ext from "../Assets/fonts/Roboto/fontRoboto700_greek_ext.woff2";
import fontRoboto700_greek from "../Assets/fonts/Roboto/fontRoboto700_greek.woff2";
import fontRoboto700_vietnamese from "../Assets/fonts/Roboto/fontRoboto700_vietnamese.woff2";
import fontRoboto700_latin_ext from "../Assets/fonts/Roboto/fontRoboto700_latin_ext.woff2";
import fontRoboto700_latin from "../Assets/fonts/Roboto/fontRoboto700_latin.woff2";
import fontRoboto900_cyrillic_ext from "../Assets/fonts/Roboto/fontRoboto900_cyrillic_ext.woff2";
import fontRoboto900_cyrillic from "../Assets/fonts/Roboto/fontRoboto900_cyrillic.woff2";
import fontRoboto900_greek from "../Assets/fonts/Roboto/fontRoboto900_greek.woff2";
import fontRoboto900_vietnamse from "../Assets/fonts/Roboto/fontRoboto900_vietnamse.woff2";
import fontRoboto900_latin_ext from "../Assets/fonts/Roboto/fontRoboto900_latin_ext.woff2";
import fontRoboto900_latin from "../Assets/fonts/Roboto/fontRoboto900_latin.woff2";
import fontRoboto900_greek_ext from "../Assets/fonts/Roboto/fontRoboto900_greek_ext.woff2";

export default createGlobalStyle`
    *{
        margin: 0;
        padding:0;
        box-sizing: border-box;
    }

    html, body, #root {
        height: 100% 100vh;
    }

    body {
        background-color: #E9EDF2;
    }

    button, input{
        border: 0;
        outline: 0;
        font-family: 'Mulish', sans-serif;
    }
    
    @font-face {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${fontLato400_01}) format('woff2');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${fontLato400_latin}) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* latin-ext */
@font-face {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(${fontLato700_latin_ext}) format('woff2');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(${fontLato700_latin}) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* latin-ext */
@font-face {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: url(${fontLato900_latin}) format('woff2');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: url(${fontLato900_latin2}) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* cyrillic-ext */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${fontMulish400_cyrillic_ext}) format('woff2');
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
}
/* cyrillic */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${fontMulish400_cyrilli}) format('woff2');
  unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}
/* vietnamese */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${fontMulish400_vietnamese}) format('woff2');
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${fontMulish400_latin_ext}) format('woff2');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${fontMulish400_latin}) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* cyrillic-ext */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url(${fontMulish600_cyrillic_ext}) format('woff2');
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
}
/* cyrillic */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url(${fontMulish600_cyrillic}) format('woff2');
  unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}
/* vietnamese */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url(${fontMulish600_vietnamese}) format('woff2');
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url(${fontMulish600_latin_ext}) format('woff2');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url(${fontMulish600_latin}) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* cyrillic-ext */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(${fontMulish700_cyrillic_ext}) format('woff2');
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
}
/* cyrillic */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(${fontMulish700_cyrillic}) format('woff2');
  unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}
/* vietnamese */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(${fontMulish700_vietnamese}) format('woff2');
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(${fontMulish700_latin_ext}) format('woff2');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(${fontMulish700_latin}) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* cyrillic-ext */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 800;
  font-display: swap;
  src: url(${fontMulish800_cyrillic_ext}) format('woff2');
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
}
/* cyrillic */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 800;
  font-display: swap;
  src: url(${fontMulish800_cyrillic}) format('woff2');
  unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}
/* vietnamese */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 800;
  font-display: swap;
  src: url(${fontMulish800_vietnamese}) format('woff2');
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 800;
  font-display: swap;
  src: url(${fontMulish800_latin_ext}) format('woff2');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 800;
  font-display: swap;
  src: url(${fontMulish800_latin}) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* cyrillic-ext */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: url(${fontMulish900_cyrillic_ext}) format('woff2');
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
}
/* cyrillic */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: url(${fontMulish900_cyrillic}) format('woff2');
  unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}
/* vietnamese */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: url(${fontMulish900_vietnamese}) format('woff2');
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: url(${fontMulish900_latin_ext}) format('woff2');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: url(${fontMulish900_latin}) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* cyrillic-ext */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${fontRoboto400_cyrillic_ext}) format('woff2');
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
}
/* cyrillic */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${fontRoboto400_cyrillic}) format('woff2');
  unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}
/* greek-ext */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${fontRoboto400_greek_ext}) format('woff2');
  unicode-range: U+1F00-1FFF;
}
/* greek */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${fontRoboto400_greek}) format('woff2');
  unicode-range: U+0370-03FF;
}
/* vietnamese */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${fontRoboto400_vietnamese}) format('woff2');
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${fontRoboto400_latin_ext}) format('woff2');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${fontRoboto400_latin}) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* cyrillic-ext */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(${fontRoboto700_cyrillic_ext}) format('woff2');
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
}
/* cyrillic */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(${fontRoboto700_cyrillic}) format('woff2');
  unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}
/* greek-ext */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(${fontRoboto700_greek_ext}) format('woff2');
  unicode-range: U+1F00-1FFF;
}
/* greek */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(${fontRoboto700_greek}) format('woff2');
  unicode-range: U+0370-03FF;
}
/* vietnamese */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(${fontRoboto700_vietnamese}) format('woff2');
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(${fontRoboto700_latin_ext}) format('woff2');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(${fontRoboto700_latin}) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* cyrillic-ext */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: url(${fontRoboto900_cyrillic_ext}) format('woff2');
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
}
/* cyrillic */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: url(${fontRoboto900_cyrillic}) format('woff2');
  unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}
/* greek-ext */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: url(${fontRoboto900_greek_ext}) format('woff2');
  unicode-range: U+1F00-1FFF;
}
/* greek */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: url(${fontRoboto900_greek}) format('woff2');
  unicode-range: U+0370-03FF;
}
/* vietnamese */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: url(${fontRoboto900_vietnamse}) format('woff2');
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: url(${fontRoboto900_latin_ext}) format('woff2');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: url(${fontRoboto900_latin}) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

.ba-alert {
    font-family: 'Mulish', 'Lato', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    border-radius: 8px;
    padding: 20px;
    position: relative;
    display: flex;
    border: 1px solid;
    display: grid;

    a, span{
        font-size: 14px;
        margin-left: 65px;
        padding-right: 20px;
        font-family: 'Mulish', 'Lato', 'Helvetica Neue', Helvetica, Arial, sans-serif;
        font-weight: 600;
    }

    span{        
        &::before{
            content: '';
            position: absolute;
            width: 30px;
            height: 30px;
            background-repeat: no-repeat;
            left: 20px;
            top: calc(50% - 18.5px);
            background-position: center;
            border-radius: 8px;
            padding: 3px;
            
        }
    }

    // Colors
    &.ba-error{
        span::before{
            background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_1213_1097)'%3E%3Cpath d='M2.73004 21.0001H21.26C22.03 21.0001 22.51 20.1701 22.13 19.5001L12.86 3.50006C12.47 2.83006 11.51 2.83006 11.13 3.50006L1.86004 19.5001C1.48004 20.1701 1.96004 21.0001 2.73004 21.0001ZM13 18.0001H11V16.0001H13V18.0001ZM12 14.0001C11.45 14.0001 11 13.5501 11 13.0001V11.0001C11 10.4501 11.45 10.0001 12 10.0001C12.55 10.0001 13 10.4501 13 11.0001V13.0001C13 13.5501 12.55 14.0001 12 14.0001Z' fill='%23FBFCFD'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_1213_1097'%3E%3Crect width='24' height='24' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
            background-color: #FF5C5C;
        }
    
        background-color: #FEE0E2;
        border-color: #FF5C5C;
    }

    &.ba-success{
        span::before{
            background-image: url("data:image/svg+xml,%3Csvg width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16.0803 0.000358912C16.0472 0.00144437 16.0143 0.00435986 15.9816 0.0090919H10.2847C10.1662 0.00741602 10.0485 0.0293086 9.93852 0.0734973C9.82855 0.117686 9.72845 0.183289 9.64406 0.266495C9.55966 0.349701 9.49264 0.44885 9.4469 0.558179C9.40116 0.667509 9.3776 0.784839 9.3776 0.90335C9.3776 1.02186 9.40116 1.13919 9.4469 1.24852C9.49264 1.35785 9.55966 1.457 9.64406 1.54021C9.72845 1.62341 9.82855 1.68901 9.93852 1.7332C10.0485 1.77739 10.1662 1.79928 10.2847 1.79761H13.9388L7.86371 7.87228C7.77788 7.95468 7.70935 8.05338 7.66215 8.16259C7.61494 8.27181 7.59 8.38934 7.58879 8.50832C7.58758 8.62729 7.61012 8.74531 7.65509 8.85546C7.70007 8.96561 7.76657 9.06569 7.85071 9.14982C7.93484 9.23395 8.03492 9.30045 8.14508 9.34542C8.25524 9.39039 8.37327 9.41293 8.49225 9.41172C8.61123 9.41051 8.72878 9.38557 8.838 9.33837C8.94722 9.29116 9.04593 9.22264 9.12833 9.13681L15.2034 3.06215V6.71603C15.2017 6.83453 15.2236 6.95218 15.2678 7.06215C15.312 7.17211 15.3776 7.2722 15.4608 7.35659C15.544 7.44098 15.6432 7.50799 15.7525 7.55373C15.8619 7.59947 15.9792 7.62302 16.0977 7.62302C16.2162 7.62302 16.3336 7.59947 16.4429 7.55373C16.5523 7.50799 16.6514 7.44098 16.7346 7.35659C16.8178 7.2722 16.8834 7.17211 16.9276 7.06215C16.9718 6.95218 16.9937 6.83453 16.992 6.71603V1.01339C17.0093 0.884902 16.9984 0.754202 16.9601 0.630341C16.9219 0.506481 16.8571 0.39242 16.7704 0.296061C16.6837 0.199702 16.577 0.123348 16.4579 0.0722893C16.3387 0.0212303 16.2099 -0.00331327 16.0803 0.000358912ZM3.35369 1.35048C1.5126 1.35048 0 2.86298 0 4.70395V13.6465C0 15.4875 1.5126 17 3.35369 17H12.2969C14.138 17 15.6506 15.4875 15.6506 13.6465V9.3988C15.6522 9.2803 15.6303 9.16265 15.5862 9.05269C15.542 8.94272 15.4764 8.84264 15.3931 8.75825C15.3099 8.67385 15.2108 8.60684 15.1014 8.5611C14.9921 8.51536 14.8748 8.49181 14.7562 8.49181C14.6377 8.49181 14.5204 8.51536 14.4111 8.5611C14.3017 8.60684 14.2026 8.67385 14.1193 8.75825C14.0361 8.84264 13.9705 8.94272 13.9263 9.05269C13.8821 9.16265 13.8603 9.2803 13.8619 9.3988V13.6465C13.8619 14.517 13.1674 15.2115 12.2969 15.2115H3.35369C2.48321 15.2115 1.78864 14.517 1.78864 13.6465V4.70395C1.78864 3.83353 2.48321 3.139 3.35369 3.139H7.6017C7.72021 3.14067 7.83787 3.11878 7.94784 3.07459C8.05782 3.0304 8.15791 2.9648 8.2423 2.88159C8.3267 2.79839 8.39372 2.69924 8.43946 2.58991C8.4852 2.48058 8.50876 2.36325 8.50876 2.24474C8.50876 2.12623 8.4852 2.0089 8.43946 1.89957C8.39372 1.79024 8.3267 1.69109 8.2423 1.60788C8.15791 1.52468 8.05782 1.45907 7.94784 1.41488C7.83787 1.3707 7.72021 1.3488 7.6017 1.35048H3.35369Z' fill='%23FBFCFD'/%3E%3C/svg%3E%0A");
            background-color: #20E4B3;
        }

        background-color: #E8FCF7;
        border-color: #20E4B3;
    }

    &.ba-warning{
        span::before{
            background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM13.2 18H10.8V10.8H13.2V18ZM13.2 8.4H10.8V6H13.2V8.4Z' fill='%23FBFCFD'/%3E%3C/svg%3E");
            background-color: #FFAF24;
        }

        background-color: #FFF6E5;
        border-color: #FFAF24;
    }

    &.ba-info{
        span::before{
            background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM13.2 18H10.8V10.8H13.2V18ZM13.2 8.4H10.8V6H13.2V8.4Z' fill='%23FBFCFD'/%3E%3C/svg%3E");
            background-color: #0080FC;
        }

        background-color: #E5F2FF;
        border-color: #0080FC;
    }
}
`;